import { CSSProperties } from "react";

import removeCursor from "@app/assets/map/cursor/minus.png";
import toggleCursor from "@app/assets/map/cursor/plus-minus.png";
import addCursor from "@app/assets/map/cursor/plus.png";

import { ContinuousSelectionMode } from "./useContinuousSelectionMode";

const getCursor = (continuousSelectionMode: ContinuousSelectionMode): CSSProperties["cursor"] => {
  switch (continuousSelectionMode) {
    case "add":
      return `url(${addCursor}) 6 7, auto`;
    case "remove":
      return `url(${removeCursor}) 6 7, auto`;
    case "toggle":
      return `url(${toggleCursor}) 6 7, auto`;
    default:
      return "pointer";
  }
};

export default getCursor;
